module.exports = __webpack_public_path__ + "img/record2-fill.a4b3affb.svg";